import {
  faBooks,
  faCardsBlank
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import SkeletonGrid from '../../../../../components/SkeletonLoader/SkeletonGrid';

const PreviewHeader = ({
  printLabel,
  isLoading,
  onCreateFlashcard,
  isVocabuloryPrint = false
}) => {
  const handleBackButtonClick = () => {
    window.history.back();
  };

  return (
    <div className="vocabulary-heading mb-4 p-0 preview-header">
      {isLoading ?
        <div className='p-4'>
          <SkeletonGrid
            rowCount={1}
            colCount={1}
            className='mt-2' />
          <SkeletonGrid
            rowCount={1}
            colCount={2}
            className='mt-2' />
        </div> : 
        <div className="d-flex justify-content-between p-4">
          <div className='btn-wrapper d-flex align-items-center'>
            <h2 className='primary-title m-0'>{printLabel}</h2>
          </div>
          <div className="align-items-center btn-wrapper d-flex gap-3">
            <div className={`d-flex mt-1 gap-3 ${isVocabuloryPrint ? '' : 'd-none'}`}>
              <button className="btn flashcard-btn d-flex gap-2 p-0 h-100 align-items-baseline" onClick={onCreateFlashcard}>
                <FontAwesomeIcon icon={faCardsBlank} /> Create Flashcard
              </button>
              <button className="btn studyset-btn d-flex gap-2 p-0 h-100 align-items-baseline d-none">
                <FontAwesomeIcon icon={faBooks} /> Create Study Set
              </button>
            </div>
            <button className="btn btn-castleWhite btn-width" onClick={handleBackButtonClick}>
              Back
            </button>
          </div>
        </div>}
    </div>
  );
};

PreviewHeader.propTypes = {
  printLabel: PropTypes.string,
  isLoading: PropTypes.bool,
  isVocabuloryPrint: PropTypes.bool,
  onCreateFlashcard: PropTypes.func
};

export default PreviewHeader;
